export default "# Toy GPU performace simulator\n* One\n* Two\n  * Three\n___\n```console\n$ kill me\n```"